import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import { Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import _ from 'lodash';
import { IsEmpty } from '../../common/checks';

const HighlightTable = (props) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [data, setData] = React.useState('');

  const handleOpenModal = (highlight) => {
    setOpenModal(true);
    setData(highlight);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setData('');
  };

  const handleEdit = (highlight) => {
    props.handleUpdate(highlight);
  };

  const onClickDelete = (e) => {
    e.preventDefault();
    props.handleDelete(data);
    handleCloseModal();
  };

  return (
    <div>
      <MaterialTable
        title=""
        columns={[
          { title: 'Display Order', field: 'displayOrder' },
          { title: 'Highlight ID', field: 'id' },
          { title: 'Title', field: 'title' },
          { title:  'Page ID', field:  'pageId', render: (highlight) => (!IsEmpty(highlight.pageId) ? (
            <a target="_blank" rel="noreferrer" href={`/admin/page/${highlight.pageId}`}>
              {highlight.pageId}
            </a>
          ) : '--') },
          { title:  'Page Name', field:  'pageName', render: (highlight) => (!IsEmpty(highlight.pageName) ? (
            <a target="_blank" rel="noreferrer" href={`/admin/page/${highlight.pageId}`}>
              {highlight.pageName}
            </a>
          ) : '--') },
          { title:  'Grouped', field:  'group', render: (highlight) => {
            if (!IsEmpty(highlight.group)) {
              return _.map(highlight.group, (g, i) => <Chip key={i} label={`${g.pageId} - ${g.pageName}`} className="mb-1 mr-1" />);
            }
          } },
        ]}
        data={props.highlights ? _.sortBy(props.highlights, 'displayOrder') : []}
        actions={[
          {
            icon:    'edit',
            tooltip: 'Update Highlight',
            onClick: (event, highlight) => {
              handleEdit(highlight);
            },
          },
          {
            icon:    'delete',
            tooltip: 'Delete Highlight',
            onClick: (event, highlight) => {
              handleOpenModal(highlight);
            },
          },
        ]}
        options={{
          actionsColumnIndex:  -1,
          search:              true,
          sorting:             false,
          paging:              true,
          pageSize:            20,
          emptyRowsWhenPaging: false,
        }}
      />
      <Dialog
        fullWidth
        size="sm"
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Highlight</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this highlight?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { onClickDelete(e); }} color="default" className="mr-3">Delete</Button>
          <Button onClick={handleCloseModal} color="primary">Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

HighlightTable.propTypes = {
  highlights:   PropTypes.arrayOf(PropTypes.shape({})),
  handleUpdate: PropTypes.func,
  handleDelete: PropTypes.func,
};

HighlightTable.defaultProps = {
  highlights:   [],
  handleUpdate: () => null,
  handleDelete: () => null,
};

export default HighlightTable;
